export const environment = {
  production:  false,
  environment: 'dev',
  msalConfig: {
    auth: {
      clientId: 'f9e6128a-1ca0-4b99-81f9-718d88698e31',
      authority: 'https://login.microsoftonline.com/fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
      redirectUri: 'https://cat-dev.azure.chevron.com',
    },
  },
  apiConfig: {
    uri: 'https://cat-backend-dev.azure.chevron.com/',
    scopes: ['https://cat-test.azure.chevron.com/user_impersonation'],
  },
};
